(function ($) {
  $(document).on('click', '.ajax-success-modal.halo-modal .halo-modal-body .cart-popup-action .btn-actions .checkbox-group label', function (e) {
    var inputTrigger= $(this).parent().find('.conditions');
  
    if (inputTrigger.is(':checked')) {
      $(this).css("color", "#232323");
    } else {
      $(this).css("color", "red");
    }
  });
})(jQuery);
